import { ConcreteEncodable } from "./ConcreteEncodable";

import { SystemControlImplEncoder } from "../../encoder/SystemControlImplEncoder";

import * as CubiqTS from "../../index";
import { SystemControl } from "../SystemControl";

export class SystemControlImpl extends ConcreteEncodable implements SystemControl {
  public static enType: string = "com.bcdfx.model.SystemControlImpl";

  /*FID=1*/
  public systemControlType: CubiqTS.SystemControlType;
  /*FID=2*/
  public systemControlSubType: CubiqTS.SystemControlSubType;
  /*FID=3*/
  public currencyPairCd: string;
  /*FID=4*/
  public systemControlStatus: CubiqTS.SystemControlStatus;
  /*FID=100*/
  public messageId: string;
  public sessionOnly: string;

  constructor() {
    super();
    this.encoder = SystemControlImplEncoder.Instance;
    this.setEncodableType(SystemControlImpl.enType);
    //Model
  }

  public toString(): string {
    return (
      "SystemControlImpl[" +
      "systemControlType=" +
      this.systemControlType +
      "systemControlSubType=" +
      this.systemControlSubType +
      "currencyPairCd=" +
      this.currencyPairCd +
      "systemControlStatus=" +
      this.systemControlStatus +
      "messageId=" +
      this.messageId +
      "]"
    );
  }

  public validateInbound(): void {}

  public validateOutbound(): void {}
}
